
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const DonutChart = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="DonutChart" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M8 0a8 8 0 108 8 8 8 0 00-8-8zm6.975 7.5h-2.026A4.973 4.973 0 008.5 3.051V1.025A7 7 0 0114.975 7.5zM4 8a4 4 0 114 4 4 4 0 01-4-4zM1 8a7 7 0 016.5-6.975v2.026a4.949 4.949 0 00-3.354 8.1l-1.43 1.431A6.964 6.964 0 011 8zm7 7a6.964 6.964 0 01-4.577-1.716l1.431-1.43A4.949 4.949 0 0012.949 8.5h2.026A7 7 0 018 15z" />
</svg>
    </HvIconBase>
)};

DonutChart.propTypes = HvIconBase.propTypes;

export default DonutChart;